module.exports = __webpack_public_path__ + "static/media/illustration-clean.c6df1f3b.svg";